import { useTranslation } from "react-i18next";

const benefits = [
  {
    icon: "ri-flashlight-line",
    color: "bg-primary-100 text-primary-600",
  },
  {
    icon: "ri-verified-badge-line",
    color: "bg-accent-100 text-accent-600",
  },
  {
    icon: "ri-scales-3-line",
    color: "bg-secondary-100 text-secondary-700",
  },
  {
    icon: "ri-shopping-bag-3-line",
    color: "bg-primary-100 text-primary-600",
  },
];

export default function WhySection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            {t("why.title")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            {t("why.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {benefits.map((benefit, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center mb-4 ${benefit.color}`}>
                <i className={`${benefit.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {t(`why.card${idx + 1}.title`)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t(`why.card${idx + 1}.desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}